import PostModel from '../model/posts'
import {ADD_TO_POSTS,ADD_VIEWS,DELETE_HISTORY,DELETE_POST,UPDATE_POST,REORDER_USER_POSTS} from './actions'
import {GET_POSTS,GET_POSTSS,GET_USER_POSTS} from '../data/posts_data'
import {GET_POST,GET_LAV} from '../data/like_data'
import {GET_VISTED_POSTS} from '../data/comment_data'

const mergeUnique = (current = [], next = []) => {
  const seen = new Set((current || []).map(item => String(item?.id || '')))
  const extra = (next || []).filter(item => {
    const id = String(item?.id || '')
    if (!id || seen.has(id)) return false
    seen.add(id)
    return true
  })
  return extra.length ? current.concat(extra) : current
}

const bumpViews = (list, postid) => (list || []).map(post => String(post?.id) === String(postid)
  ? { ...post, views: Number(post.views || 0) + 1 }
  : post)

const initalState = {
  lav:[],
  Posts:[],
  vistedPost:[],
  userPosts:[],
  history:[],
  followShort:[],
  followLong:[],
  post:{}
}
export default (state=initalState,actions) =>{
  switch (actions.type) {
    case ADD_VIEWS: {
      const postid = actions.postid
      const post = state.post && String(state.post.id) === String(postid)
        ? { ...state.post, views: Number(state.post.views || 0) + 1 }
        : state.post
      return {
        ...state,
        post,
        Posts: bumpViews(state.Posts, postid),
        userPosts: bumpViews(state.userPosts, postid),
        history: bumpViews(state.history, postid),
        followShort: bumpViews(state.followShort, postid),
        followLong: bumpViews(state.followLong, postid),
        vistedPost: bumpViews(state.vistedPost, postid),
        lav: bumpViews(state.lav, postid)
      }
    }
    case ADD_TO_POSTS:
    const post = new PostModel(actions.postData.id,actions.postData.image,actions.postData.title,actions.postData.type,actions.postData.userid,actions.postData.tages,actions.postData.description,new Date().toString(),actions.postData.thumbnail);
    return{
      ...state,userPosts:state.userPosts.concat(post)
    }
    case GET_POSTS:
    return{
      ...state,
      history:actions.datahistory,
      followLong:actions.followlong,
      followShort:actions.followshort
    }
    case GET_POSTSS:
    return{
      ...state,
      history: mergeUnique(state.history, actions.datahistory),
      followLong: mergeUnique(state.followLong, actions.followlong),
      followShort: mergeUnique(state.followShort, actions.followshort)
    }
    case GET_USER_POSTS:
    return{
      ...state,
      userPosts:actions.data
    }
    case DELETE_POST:
    return{
      ...state,
      userPosts:state.userPosts.filter(post => post.id !== actions.id)
    }
    case UPDATE_POST:
    return{
      ...state,
      userPosts:state.userPosts.map(post => post.id === actions.post.id ? { ...post, ...actions.post } : post)
    }
    case REORDER_USER_POSTS: {
      const rank = new Map((actions.ids || []).map((id, index) => [String(id), index]))
      if (!rank.size) return state
      const moved = state.userPosts.filter(post => rank.has(String(post.id)))
        .sort((a, b) => rank.get(String(a.id)) - rank.get(String(b.id)))
      if (!moved.length) return state
      let next = 0
      return {
        ...state,
        userPosts: state.userPosts.map(post => rank.has(String(post.id)) ? moved[next++] : post)
      }
    }
    case DELETE_HISTORY:
    return{
      ...state
      ,history:state.history.filter(post => post.id !== actions.id),

    }
    case GET_POST:
    return{
      ...state,
      post:actions.data[0]}

      case GET_LAV:
      return{
        ...state,
        lav:actions.data}

      case GET_VISTED_POSTS:
      return{
        ...state,
        vistedPost:actions.data}
  }


  return state;
}
